import { axiosGet } from '../../../app/Helpers/AxiosHelper';

export default {

    state: {
        clientList: [],
        productList: [],
        siteList: [],
        transporterList: [],
        locationList: [],
        locationTypeList: [],
        destinationList: [],
        transitList: [],
        statusList: [],
        escorterList: [],
        vehiculeList: [],
        userList: [],
    },

    getters: {
        getProductTrip: state => {
            return state.productList
        },
        getClientTrip: state => {
            return state.clientList
        },
        getSiteTrip: state => {
            return state.siteList
        },
        getTransporterTrip: state => {
            return state.transporterList
        },
        getLocationTrip: state => {
            return state.locationList
        },
        getLocationTypeTrip: state => {
            return state.locationTypeList
        },
        getStatusTrip: state => {
            return state.statusList
        },
        getEscorterTrip: state => {
            return state.escorterList
        },
        getDestinationTrip: state => {
            return state.destinationList
        },
        getTransitTrip: state => {
            return state.transitList
        },
        getVehiculeTrip: state => {
            return state.vehiculeList
        },
        getUserTrip: state => {
            return state.userList
        },
    },

    actions: {
        getClients({ commit }) {
            const url = '/support/clients';
            axiosGet(url).then(res => {
                commit('SET_CLIENTS', res.data);
            });
        },
        getProducts({ commit }) {
            const url = '/support/products';
            axiosGet(url).then(res => {
                commit('SET_PRODUCTS', res.data);
            });
        },
        getSites({ commit }) {
            const url = '/support/sites';
            axiosGet(url).then(res => {
                commit('SET_SITES', res.data);
            });
        },
        getTransporters({ commit }) {
            const url = '/support/transporters';
            axiosGet(url).then(res => {
                commit('SET_TRANSPORTERS', res.data);
            });
        },
        getLocations({ commit }) {
            const url = '/support/locations';
            axiosGet(url).then(res => {
                commit('SET_LOCATIONS', res.data);
            });
        },
        getLocationTypes({ commit }) {
            const url = '/support/location-types';
            axiosGet(url).then(res => {
                commit('SET_LOCATION_TYPES', res.data);
            });
        },
        getDestinations({ commit }) {
            const url = '/support/destinations';
            axiosGet(url).then(res => {
                commit('SET_DESTINATIONS', res.data);
            });
        },
        getTransits({ commit }) {
            const url = '/support/transits';
            axiosGet(url).then(res => {
                commit('SET_TRANSITS', res.data);
            });
        },
        getStatus({ commit }) {
            const url = '/support/status';
            axiosGet(url).then(res => {
                commit('SET_STATUS', res.data);
            });
        },
        getEscorters({ commit }) {
            const url = '/support/escorters';
            axiosGet(url).then(res => {
                commit('SET_ESCORTERS', res.data);
            });
        },
        getVehicules({ commit }) {
            const url = '/support/vehicules';
            axiosGet(url).then(res => {
                commit('SET_VEHICULES', res.data);
            });
        },
        getSupportUsers({ commit }) {
            const url = '/support/users';
            axiosGet(url).then(res => {
                commit('SET_USERS', res.data);
            });
        },

    },

    mutations: {
        SET_CLIENTS(state, clients) {
            state.clientList = clients;
        },
        SET_PRODUCTS(state, products) {
            state.productList = products;
        },
        SET_SITES(state, sites) {
            state.siteList = sites;
        },
        SET_TRANSPORTERS(state, transporters) {
            state.transporterList = transporters;
        },
        SET_LOCATIONS(state, locations) {
            state.locationList = locations;
        },
        SET_LOCATION_TYPES(state, locationTypes) {
            state.locationTypeList = locationTypes;
        },
        SET_DESTINATIONS(state, destinations) {
            state.destinationList = destinations;
        },
        SET_TRANSITS(state, transits) {
            state.transitList = transits;
        },
        SET_STATUS(state, status) {
            state.statusList = status;
        },
        SET_ESCORTERS(state, escorters) {
            state.escorterList = escorters;
        },
        SET_VEHICULES(state, vehicules) {
            state.vehiculeList = vehicules;
        },
        SET_USERS(state, users) {
            state.userList = users;
        }
    }
}
